import React from "react";

const CustomCheckbox = ({
    checked = false,
    onChange,
    disabled = false,
    className = "",
    size = "medium",
    label = "",
    icon,
    checkedIcon,
    style,
    ...props
}) => {
    const isChecked = Boolean(checked);
    const handleChange = (event) => {
        if (!disabled && onChange) {
            onChange(event);
        }
    };

    const handleClick = (event) => {
        if (!disabled && onChange) {
            // Create synthetic event if clicking on the container
            if (event.target.type !== "checkbox") {
                const syntheticEvent = {
                    target: {
                        type: "checkbox",
                        checked: !isChecked,
                    },
                };
                onChange(syntheticEvent);
            }
        }
    };

    const sizeClasses = {
        small: "w-4 h-4",
        medium: "w-5 h-5",
        large: "w-6 h-6",
    };

    const checkboxClasses = `appearance-none border-2 border-gray-300 rounded-sm transition-all duration-200 cursor-pointer ${
        sizeClasses[size]
    } ${
        isChecked && !disabled
            ? "bg-primary border-primary"
            : !isChecked && !disabled
            ? "bg-gray-100 border-gray-300"
            : disabled
            ? "bg-gray-200 border-gray-300 cursor-not-allowed opacity-60"
            : ""
    } ${!disabled && !isChecked ? "hover:border-primary/70" : ""} ${className}`;

    return (
        <div
            className={`inline-flex items-center cursor-pointer ${
                Boolean(label) ? "gap-4" : ""
            }`}
            onClick={handleClick}
            style={{
                cursor: disabled ? "not-allowed" : "pointer",
                ...(style || {}),
            }}
        >
            <div className={`relative ${sizeClasses[size]}`}>
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleChange}
                    disabled={disabled}
                    readOnly={!onChange}
                    className={checkboxClasses}
                    {...props}
                />
                {isChecked ? (
                    <svg
                        className="absolute inset-0 w-full h-full text-white pointer-events-none"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                    >
                        <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                        />
                    </svg>
                ) : null}
            </div>
            {label && (
                <span
                    className={`text-base ${
                        !disabled ? "text-gray-900" : "text-gray-500"
                    }`}
                >
                    {label}
                </span>
            )}
        </div>
    );
};

export default CustomCheckbox;
